import React, { Component } from "react";
import {
  Container,
  Box,
  Grid,
  Typography,
  Button,
  Paper,
  Card,
  CardContent,
  CardActions,
  Chip,
  Avatar,
  IconButton
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import BoltIcon from '@mui/icons-material/Bolt';
import BuildIcon from '@mui/icons-material/Build';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import ComputerIcon from '@mui/icons-material/Computer';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import Groups from "../group/Groups";
import { singleGroup, groupDetails } from "../group/apigroup";
import { getChairsLatestMessage, getGroupLatestPost } from "../forum/apiForum";
import Footer from './Footer';
import { EditorState, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class Home extends Component {

  state = {
    groupId: '5e5591a97ff73f6d34835a05', //home page takes data from Leadership Group Only
    group: '',
    redirectToHome: false,
    redirectToSignin: false,
    chair: '',
    cochair: '',
    chairsMessage: '',
    shortenBody: '',
    physGroupPost: '',
    electricalGroupPost: '',
    technicalGroupPost: '',
    civilGroupPost: '',
    bizzGroupPost: '',
    innovationGroupPost: ''
  };

  componentDidMount = () => {
    localStorage.removeItem('jwt');
    singleGroup(this.state.groupId).then(groupData => {
      if (!groupData || groupData.error) {
        if (groupData && groupData.error) console.log(groupData.error);
        return;
      }
      this.setState({ group: groupData });

      groupDetails(this.state.groupId).then(detailData => {
        if (!detailData || detailData.error) {
          if (detailData && detailData.error) console.log(detailData.error);
          return;
        }
        this.setState({
          chair: detailData.chair,
          cochair: detailData.cochair
        });

        if (!detailData.chair || !detailData.chair._id) return;

        getChairsLatestMessage(detailData.chair._id).then(msgData => {
          if (!msgData || msgData.error || !msgData.body) {
            if (msgData && msgData.error) console.log(msgData.error);
            return;
          }
          try {
            this.setState({
              chairsMessage: msgData,
              shortenBody: EditorState.createWithContent(convertFromRaw(JSON.parse(msgData.body)))
            });
          } catch (parseErr) {
            console.error('Failed to parse chair message body:', parseErr);
          }
        });
      });
    });

    this.latestPhysicalGroupPost()
    this.latestElectricalGroupPost()
    this.latestTechnicalGroupPost()
    this.latestCivilGroupPost()
    this.latestBizzGroupPost()
    this.latestInnovationGroupPost()
  };

  applyLatestGroupPost = (stateKey) => (data) => {
    if (!data || data.error) {
      this.setState({ [stateKey]: '' });
      return;
    }
    this.setState({ [stateKey]: data });
  };

  latestPhysicalGroupPost() {
    getGroupLatestPost('5e2a5e764175b97d84ec6cae').then(this.applyLatestGroupPost('physGroupPost'));
  };

  latestElectricalGroupPost() {
    getGroupLatestPost('5e44050f4e6ed37ab467d0f2').then(this.applyLatestGroupPost('electricalGroupPost'));
  };

  latestTechnicalGroupPost() {
    getGroupLatestPost('5e44052e4e6ed37ab467d0f3').then(this.applyLatestGroupPost('technicalGroupPost'));
  };

  latestCivilGroupPost() {
    getGroupLatestPost('5e4405864e6ed37ab467d0f4').then(this.applyLatestGroupPost('civilGroupPost'));
  };

  latestBizzGroupPost() {
    getGroupLatestPost('5e4406454e6ed37ab467d0f5').then(this.applyLatestGroupPost('bizzGroupPost'));
  };

  latestInnovationGroupPost() {
    getGroupLatestPost('639242d4971a30726884fd85').then(this.applyLatestGroupPost('innovationGroupPost'));
  };

  render() {
    const { chair, chairsMessage, shortenBody,
      electricalGroupPost, physGroupPost, technicalGroupPost, civilGroupPost,
      bizzGroupPost, innovationGroupPost } = this.state;

    const committees = [
      {
        name: 'Business Strategy',
        post: bizzGroupPost,
        icon: <BusinessCenterIcon sx={{ fontSize: 32 }} />,
        color: '#003E7E'
      },
      {
        name: 'Civil/Structural',
        post: civilGroupPost,
        icon: <ArchitectureIcon sx={{ fontSize: 32 }} />,
        color: '#FF6600'
      },
      {
        name: 'Electrical',
        post: electricalGroupPost,
        icon: <BoltIcon sx={{ fontSize: 32 }} />,
        color: '#003E7E'
      },
      {
        name: 'Innovations',
        post: innovationGroupPost,
        icon: <LightbulbIcon sx={{ fontSize: 32 }} />,
        color: '#FF6600'
      },
      {
        name: 'Physical',
        post: physGroupPost,
        icon: <BuildIcon sx={{ fontSize: 32 }} />,
        color: '#003E7E'
      },
      {
        name: 'Technology',
        post: technicalGroupPost,
        icon: <ComputerIcon sx={{ fontSize: 32 }} />,
        color: '#FF6600'
      }
    ];

    return (
      <>
        {/* Hero Section */}
        <Box sx={{ backgroundColor: '#003E7E', color: 'white', py: 5, mb: 4 }}>
          <Container maxWidth="lg">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
              <HomeIcon sx={{ fontSize: 56 }} />
              <Box>
                <Typography variant="h3" component="h1" sx={{ fontWeight: 700 }}>
                  Welcome Back!
                </Typography>
                <Typography variant="h6" sx={{ opacity: 0.9 }}>
                  Stay updated with the latest from SDSIC
                </Typography>
              </Box>
            </Box>
          </Container>
        </Box>

        <Container maxWidth="xl" sx={{ mb: 6 }}>
          {/* Chair's Message */}
          {chairsMessage && (
            <Paper
              elevation={4}
              sx={{
                mb: 4,
                borderRadius: 3,
                overflow: 'hidden',
                border: '3px solid #FF6600'
              }}
            >
              <Box
                sx={{
                  background: 'linear-gradient(135deg, #003E7E 0%, #0055A5 100%)',
                  color: 'white',
                  p: 3
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <AnnouncementIcon sx={{ fontSize: 40 }} />
                  <Box>
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>
                      Message from Your Chair
                    </Typography>
                    <Typography variant="body1" sx={{ opacity: 0.9 }}>
                      {chair.name} {chair.lastName}
                    </Typography>
                  </Box>
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 500, mb: 1 }}>
                  {chairsMessage.title}
                </Typography>
              </Box>
              <Box sx={{ p: 4, backgroundColor: 'white' }}>
                <Box sx={{ mb: 3, '& .public-DraftEditor-content': { minHeight: '100px' } }}>
                  <Editor
                    toolbarHidden={true}
                    editorState={shortenBody}
                    readOnly={true}
                    wrapperClassName="demo-wrapper"
                    editorClassName="editer-content"
                  />
                </Box>
                <Button
                  href={`/forumpost/${chairsMessage._id}`}
                  variant="contained"
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    backgroundColor: '#FF6600',
                    '&:hover': {
                      backgroundColor: '#e55a00',
                    }
                  }}
                >
                  Read Full Message
                </Button>
              </Box>
            </Paper>
          )}

          <Grid container spacing={3}>
            {/* Committee Updates */}
            <Grid item xs={12} md={8}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                <Typography variant="h4" sx={{ fontWeight: 600, color: '#003E7E' }}>
                  Committee Updates
                </Typography>
              </Box>

              <Grid container spacing={3}>
                {committees.map((committee, index) => (
                  committee.post && (
                    <Grid item xs={12} sm={6} key={index}>
                      <Card
                        elevation={3}
                        sx={{
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          borderRadius: 3,
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: `0 8px 16px ${committee.color}40`,
                          }
                        }}
                      >
                        <Box
                          sx={{
                            p: 2,
                            backgroundColor: committee.color,
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2
                          }}
                        >
                          {committee.icon}
                          <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            {committee.name}
                          </Typography>
                        </Box>
                        <CardContent sx={{ flexGrow: 1, p: 3 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: '#003E7E',
                              mb: 2,
                              lineHeight: 1.3
                            }}
                          >
                            {committee.post.title}
                          </Typography>
                          <Chip
                            label={new Date(committee.post.created).toLocaleDateString('en-US', {
                              month: 'short',
                              day: 'numeric',
                              year: 'numeric'
                            })}
                            size="small"
                            sx={{
                              backgroundColor: 'rgba(0, 62, 126, 0.1)',
                              color: '#003E7E',
                              fontWeight: 500
                            }}
                          />
                        </CardContent>
                        <CardActions sx={{ p: 2, pt: 0 }}>
                          <Button
                            href={`/forumpost/${committee.post._id}`}
                            variant="outlined"
                            endIcon={<ArrowForwardIcon />}
                            fullWidth
                            sx={{
                              borderColor: committee.color,
                              color: committee.color,
                              '&:hover': {
                                borderColor: committee.color,
                                backgroundColor: `${committee.color}10`,
                              }
                            }}
                          >
                            Read Post
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  )
                ))}
              </Grid>

              {/* No Updates State */}
              {!committees.some(c => c.post) && (
                <Paper
                  elevation={2}
                  sx={{
                    p: 5,
                    textAlign: 'center',
                    borderRadius: 3,
                    backgroundColor: 'rgba(0, 62, 126, 0.02)'
                  }}
                >
                  <AnnouncementIcon sx={{ fontSize: 64, color: '#003E7E', opacity: 0.3, mb: 2 }} />
                  <Typography variant="h6" sx={{ color: '#003E7E', mb: 1 }}>
                    No Recent Updates
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    Check back soon for the latest committee updates
                  </Typography>
                </Paper>
              )}
            </Grid>

            {/* Sidebar */}
            <Grid item xs={12} md={4}>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  backgroundColor: 'rgba(0, 62, 126, 0.02)',
                  position: 'sticky',
                  top: 20
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: 600, color: '#003E7E', mb: 3 }}>
                  Your Committees
                </Typography>
                <Groups />
              </Paper>
            </Grid>
          </Grid>
        </Container>

        <Footer />
      </>
    )
  }
};

export default Home;
